import { useTranslation } from 'react-i18next';
import CollapsiblePanel from './CollapsiblePanel.js';
import DashboardLineChart from './DashboardLineChart.js';
import { CHART_DUE_COLOR, CHART_NEUTRAL_COLOR, CHART_PAID_COLOR } from './chartTheme.js';

const ShipmentTrendChart = ({ chartTrend, hubFilter = null, className = '', showCommissionLines = true }) => {
  const { t } = useTranslation();
  const lines = [
    { dataKey: 'paid', name: t('dashboard.paidAmount'), color: CHART_PAID_COLOR },
    { dataKey: 'balance', name: t('dashboard.balanceAmount'), color: CHART_DUE_COLOR },
    { dataKey: 'returned', name: t('dashboard.returnedAmount', { defaultValue: 'Returned Amount' }), color: CHART_NEUTRAL_COLOR },
    { dataKey: 'missing', name: t('dashboard.missingAmount', { defaultValue: 'Missing Amount' }), color: '#d97706' },
  ];
  if (showCommissionLines) {
    lines.push(
      { dataKey: 'returned_commission', name: t('dashboard.returnedCommission', { defaultValue: 'Returned Commission' }), color: '#7c3aed' },
      { dataKey: 'missing_commission', name: t('dashboard.missingCommission', { defaultValue: 'Missing Commission' }), color: '#0f766e' },
    );
  }

  return (
    <CollapsiblePanel title={t('dashboard.shipmentPaidVsBalance')} defaultOpen trailing={hubFilter} className={className}>
      <DashboardLineChart
        t={t}
        chartTrend={chartTrend}
        emptyLabel={t('common.noData')}
        lines={lines}
      />
    </CollapsiblePanel>
  );
};

export default ShipmentTrendChart;
